import "./Spinner.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from '@fortawesome/free-solid-svg-icons'


const Spinner = () => {
  return (
    <div className="spinner">
      <FontAwesomeIcon
        icon={faSpinner}
        className="spinner__icon"
        pulse
      />
    </div>
  );
};

export default Spinner;
